var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "message-dialog" },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            "content-class": [_vm.message.reason],
            fullscreen: _vm.message.fullscreen,
            persistent: _vm.message.persistent,
            "max-width": _vm.message.maxWidth
              ? _vm.message.maxWidth
              : _vm.maxWidth
          },
          model: {
            value: _vm.show,
            callback: function($$v) {
              _vm.show = $$v
            },
            expression: "show"
          }
        },
        [
          _vm.message.reason === "native-app"
            ? _c("div", [
                _vm.userAgent === "android" || _vm.userAgent === "ios"
                  ? _c("div", [
                      _c("div", { staticClass: "text-wrapper" }, [
                        _c("h1", [
                          _vm._v(_vm._s(_vm.$t("appInstaller.addTo.Title")))
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(_vm._s(_vm.$t("appInstaller.addTo.content")))
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "buttons" },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "primary-btn-blue",
                              attrs: { block: "" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.appDownload()
                                }
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "appInstaller.nativeApp" +
                                        _vm.userAgent +
                                        ".appDwn"
                                    )
                                  )
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "app-link" }, [
                            _c(
                              "a",
                              {
                                staticClass: "app-btn",
                                on: {
                                  click: function($event) {
                                    return _vm.close()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("appInstaller.addTo.continue"))
                                )
                              ]
                            )
                          ])
                        ],
                        1
                      )
                    ])
                  : _c("div", [
                      _c("div", { staticClass: "text-wrapper" }, [
                        _c("h1", { staticClass: "something-wrong" }, [
                          _vm._v(_vm._s(_vm.$t("MessageDialog.msg.unknown")))
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "buttons" },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "primary-btn-blue",
                              attrs: { block: "" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.close()
                                }
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("MessageDialog.btn.CLOSE"))
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.message.reason === "native-app-casino"
            ? _c("div", [
                _vm.userAgent === "android" || _vm.userAgent === "ios"
                  ? _c("div", [
                      _c("div", { staticClass: "text-wrapper" }, [
                        _c("h1", [
                          _vm._v(
                            _vm._s(_vm.$t("appInstaller.addTo.Title.Casino"))
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            _vm._s(_vm.$t("appInstaller.addTo.content.Casino"))
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "buttons" },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "primary-btn-blue",
                              attrs: { block: "" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.appDownload()
                                }
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "appInstaller.nativeApp" +
                                        _vm.userAgent +
                                        ".appDwn"
                                    )
                                  )
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "app-link" }, [
                            _c(
                              "a",
                              {
                                staticClass: "app-btn",
                                on: {
                                  click: function($event) {
                                    return _vm.close()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("appInstaller.addTo.continue.Casino")
                                  )
                                )
                              ]
                            )
                          ])
                        ],
                        1
                      )
                    ])
                  : _c("div", [
                      _c("div", { staticClass: "text-wrapper" }, [
                        _c("h1", { staticClass: "something-wrong" }, [
                          _vm._v(_vm._s(_vm.$t("MessageDialog.msg.unknown")))
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "buttons" },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "primary-btn-blue",
                              attrs: { block: "" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.close()
                                }
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("MessageDialog.btn.CLOSE"))
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ])
              ])
            : _vm.message.reason === "native-failed-geolocation"
            ? _c("div", { class: [_vm.message.reason, _vm.brandKey] }, [
                _vm.userAgent === "android" || _vm.userAgent === "ios"
                  ? _c("div", [
                      _c("div", { staticClass: "text-wrapper" }, [
                        _c("h1", [
                          _vm._v(
                            _vm._s(_vm.$t("nativeApp.failedGeolocation.title"))
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "nativeApp.failedGeolocation.contect." +
                                  _vm.state
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _vm.brandKey === "sb"
                          ? _c("p", {
                              style: "margin-top: 20px",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t(
                                    "nativeApp.failedGeolocation.contect2." +
                                      _vm.state
                                  )
                                )
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.brandKey !== "sb"
                          ? _c("p", { staticClass: "msg-red" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "nativeApp.failedGeolocation.suggestion"
                                  )
                                )
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "buttons" },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "primary-btn-blue",
                              attrs: { block: "" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.close()
                                }
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("Geolocation.ErrorMessage.OK"))
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  : _c("div", [
                      _c("div", { staticClass: "text-wrapper" }, [
                        _c("h1", { staticClass: "something-wrong" }, [
                          _vm._v(_vm._s(_vm.$t("MessageDialog.msg.unknown")))
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "buttons" },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "primary-btn-blue",
                              attrs: { block: "" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.close()
                                }
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("MessageDialog.btn.CLOSE"))
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ])
              ])
            : _vm.message.reason === "firstVisit"
            ? _c("div", { class: [_vm.message.reason] + "-content" }, [
                _vm.userAgent === "android" || _vm.userAgent === "ios"
                  ? _c(
                      "div",
                      [
                        _c(
                          "v-flex",
                          { staticClass: "close" },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "close",
                                attrs: { flat: "" },
                                on: {
                                  click: function($event) {
                                    return _vm.close()
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("close")])],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "promo-content" }, [
                          _c("div", { staticClass: "promo-image" }, [
                            _c("img", {
                              attrs: {
                                src:
                                  _vm.currentBoNavigationHeadlines[0].imageurl
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("h1", { staticClass: "title" }, [
                            _vm._v(
                              _vm._s(_vm.currentBoNavigationHeadlines[0].title)
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "bodytext" }, [
                            _vm._v(
                              _vm._s(
                                _vm.currentBoNavigationHeadlines[0].bodytext
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "promotext" }, [
                            _vm._v(
                              _vm._s(
                                _vm.currentBoNavigationHeadlines[0].promotext
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "buttons" },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "primary-btn-green",
                                attrs: {
                                  href: _vm.externalUrls.addFunds + _vm.webView,
                                  target: "_self",
                                  block: ""
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.currentBoNavigationHeadlines[0]
                                        .datetimetext
                                    )
                                  )
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _c("div", [
                      _c("div", { staticClass: "text-wrapper" }, [
                        _c("h1", { staticClass: "something-wrong" }, [
                          _vm._v(_vm._s(_vm.$t("MessageDialog.msg.unknown")))
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "buttons" },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "primary-btn-blue",
                              attrs: { block: "" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.close()
                                }
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("MessageDialog.btn.CLOSE"))
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ])
              ])
            : _vm.message.reason === "session-notifier"
            ? _c("div", { class: [_vm.message.reason] }, [
                _c("div", { staticClass: "text-wrapper" }, [
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t("Session.information")) + " "),
                    _vm.timeLeft
                      ? _c("span", [_vm._v(_vm._s(_vm.timeLeft))])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "buttons" },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "primary-btn-blue",
                        attrs: { block: "" },
                        on: {
                          click: function($event) {
                            return _vm.extendSession()
                          }
                        }
                      },
                      [_c("span", [_vm._v(_vm._s(_vm.$t("Session.extend")))])]
                    ),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        staticClass: "primary-btn-blue",
                        attrs: { block: "" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.close(false)
                          }
                        }
                      },
                      [_c("span", [_vm._v(_vm._s(_vm.$t("Session.close")))])]
                    )
                  ],
                  1
                )
              ])
            : _vm.message.reason === "network-error"
            ? _c("div", { class: [_vm.message.reason] }, [
                _c("div", { staticClass: "text-wrapper" }, [
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t("MessageDialog.networkError")))
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "buttons" },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "primary-btn-blue",
                        attrs: { block: "" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.close(false)
                          }
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("MessageDialog.btn.CLOSE")))
                        ])
                      ]
                    )
                  ],
                  1
                )
              ])
            : _vm.message.reason === "conflict"
            ? _c("div", { class: [_vm.message.reason] }, [
                _c("div", { staticClass: "text-wrapper" }, [
                  _c("h1", { staticClass: "something-wrong" }, [
                    _vm._v(_vm._s(_vm.$t("MessageDialog.msg.unknown")))
                  ]),
                  _vm._v(" "),
                  _vm.message.err && _vm.message.err.errorCode === "20282"
                    ? _c("p", [
                        _vm._v(_vm._s(_vm.$t("MessageDialog.DoubleWagerError")))
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "buttons" },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "primary-btn-blue",
                        attrs: { block: "" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.close(false)
                          }
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("MessageDialog.btn.CLOSE")))
                        ])
                      ]
                    )
                  ],
                  1
                )
              ])
            : _c("div", [
                _c("div", { staticClass: "text-wrapper" }, [
                  _c("p", { staticClass: "something-wrong" }, [
                    _vm._v(_vm._s(_vm.$t("MessageDialog.msg.unknown")))
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "buttons" },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "primary-btn-blue",
                        attrs: { block: "" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.close()
                          }
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("MessageDialog.btn.CLOSE")))
                        ])
                      ]
                    )
                  ],
                  1
                )
              ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cbd4156a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbd4156a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/parts/MessageDialog.vue
// module id = null
// module chunks = 